import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/reset.css';
import App from './App';
import { BrowserRouter } from "react-router";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    <BrowserRouter>
      <App />
    </BrowserRouter>,

  </React.StrictMode>
);

